export default __webpack_public_path__ + "static/media/bokeh.ae1dded2.png";